import { AuthMode } from "./auth-mode";

export class LoginRequest {
  login: string | null = null;
  password: string | null = null;
  platformId: number | null = 0;
  authmode: AuthMode | null = null;

  constructor(init?: Partial<LoginRequest>) {
    Object.assign(this, init);
  }
}
